import { html } from '@design.estate/dees-element';

export const mainPage = () => html`
  <dees-input-text label="my-test-label"></dees-input-text>
  <dees-input-text label="my-test-label"></dees-input-text>
`;